// navigation actions
export const ROUTER_HASH_UPDATED = { label: 'Hash updated', event: 'hashUpdated' }
